import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { mustResetPassword } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

export function MustResetPasswordGuard(): React.JSX.Element {
  const needResetPassword = useAppSelector(mustResetPassword);
  const navigate = useNavigate();

  useEffect(() => {
    if (needResetPassword) {
      navigate(APP_PATH.MUST_RESET_PASSWORD);
    }
  }, [needResetPassword, navigate]);

  return <Outlet />;
}
